const getters = {
  // 数据字典
  dict_data: state => state.dict.dictData
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js